module.exports = __webpack_public_path__ + "img/up2.3084f349.png";